// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DataTableProps } from "@insite/mobius/DataTable";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getNotifyStyle } from "@vanmeter/App/Components/Notify";
import IconPaginationArrowRight from "@vanmeter/XDL/Icons/IconPaginationArrowRight";
import { css } from "styled-components";

interface DataTableStyles {
    container?: InjectableCss;
    dataTable?: DataTableProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    viewAllLinkStyle?: LinkPresentationProps;
}

const dataTableStyles: DataTableStyles = {
    noResultsContainer: {
        css: css`
            text-align: center;
        `,
    },
    noResultsText: {
        ...getNotifyStyle("danger", true),
    },
    dataTable: {
        css: css`
            td[class^="DataTableCellBase"] {
                &:empty:after,
                & > ${TypographyStyle}:empty:after {
                    content: "- -";
                }
            }
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    viewAllLinkStyle: {
        icon: {
            iconProps: {
                src: IconPaginationArrowRight,
                size: 16,
            },
            position: "right",
        },
        css: css`
            margin-top: 16px;
        `,
    },
};

export default dataTableStyles;
